import { createReducer } from "redux-act";

import * as a from "../actions/ideActivitySets";

const getDefaultState = () => ({
  isLoadingProgramIdeSets: true,
  programIdeProjects: [],
  userIdeProjects: [],
});

export default () =>
  createReducer(
    {
      [a.getProgramIdeActivitySets]: (state) => {
        return {
          ...state,
          isLoadingProgramIdeSets: true,
        };
      },
      [a.receivedProgramIdeActivitySets]: (state, payload) => {
        return {
          ...state,
          programIdeProjects: payload,
          isLoadingProgramIdeSets: false,
        };
      },
      [a.getProgramIdeActivitySetsError]: (state) => ({
        ...state,
        isLoadingProgramIdeSets: false,
      }),
      [a.getUserIdeActivitySets]: (state) => {
        return {
          ...state,
          isLoadingProgramIdeSets: true,
        };
      },
      [a.receivedUserIdeActivitySets]: (state, payload) => {
        return {
          ...state,
          userIdeProjects: payload,
          isLoadingProgramIdeSets: false,
        };
      },
      [a.getUserIdeActivitySetsError]: (state) => ({
        ...state,
        isLoadingProgramIdeSets: false,
      }),
    },
    getDefaultState()
  );
